"use client";

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import electricIcon from "../Assets/electricIcon.svg";
import goodmarkImg from "../Assets/goodmarkImg.svg";
import plan1 from "../Assets/plan1.png";
import plan2 from "../Assets/plan2.png";
import plan3 from "../Assets/plan3.png";
import { handleError } from "../CommonJquery/CommonJquery";
import { retrieveData, storeData } from "../LocalConnection/LocalConnection";
import "./CSS/Pricing.css";

import {
  edit_profile,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import Loader from "../pages/Loader";

export default function Pricing() {
  const navigate = useNavigate();
  const plan = Number.parseFloat(retrieveData("price_amount_package"));
  const activePlan = plan % 1 === 0 ? plan.toFixed(0) : plan.toFixed(2);
  console.log(activePlan);
  const handlepayment = (plan) => {
    storeData("PackageName", plan.title);
    storeData("PackageTime", plan.Duraction);
    storeData("price_amount", plan.price_amount);
    navigate("/Onboard");
  };

  const handleStartFreeTrial = (plan) => {
    storeData("PackageName", plan.title);
    storeData("PackageTime", 14); // 14 days free trial
    storeData("price_amount", "0"); // Free trial
    storeData("TrialPlan", plan.price_amount); // Store original plan price for after trial
    navigate("/Onboard");
  };

  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [businessName, setBusinessName] = useState("");
  const [businessLocation, setBusinessLocation] = useState("");
  const [businessWebsite, setBusinessWebsite] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [phoneManager, setPhoneManager] = useState("");
  const [activeTab, setActiveTab] = useState("monthly");
  const [isIndianUser, setIsIndianUser] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [pricingPlansnew, setpricingPlansnew] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState("india"); // defaul

  const [gst, setgst] = useState("");

  const handleNavigate = () => {
    navigate("https://www.wowreviews.co/Home/contact_us", { target: "_blank" });
  };

  // Function to detect user's country
  // Function to detect user's country
  const detectUserCountry = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      const country = data.country_code === "IN" ? "india" : "usa";
      setSelectedCountry(country);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      await detectUserCountry(); // wait for country detection
    };
    initialize();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      master_data_get(); // only call this once selectedCountry is set
    }
  }, [selectedCountry, activeTab]);
  const planImages = {
    "plan1.svg": plan1,
    "plan2.svg": plan2,
    "plan3.svg": plan3,
  };

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    await server_post_data(edit_profile, null)
      .then((Response) => {
        const data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          console.log(final_data);
          if (final_data.edit_user.length > 0) {
            console.log(final_data.edit_business);
            setBusinessName(final_data.edit_business[0].business_name);
            setBusinessEmail(final_data.edit_business[0].bus_email);
            setBusinessLocation(final_data.edit_business[0].business_location);
            setgst(final_data.edit_business[0].gst_no);
            setPhoneManager(final_data.edit_business[0].bus_moblie_no);
            setBusinessWebsite(
              final_data.edit_business[0].business_website_url,
            );

            storeData(
              "bussinessname",
              final_data.edit_business[0].business_name,
            );
            storeData("category_id", final_data.edit_business[0].category_id);
            storeData("phoneNumber", final_data.edit_business[0].bus_moblie_no);
            storeData("email", final_data.edit_business[0].bus_email);
            storeData(
              "website",
              final_data.edit_business[0].business_website_url,
            );
            storeData(
              "location",
              final_data.edit_business[0].business_location,
            );
            storeData("gstdata", final_data.edit_business[0].gst_no);
            const updatedPlans = final_data.price_data.map((plan) => {
              if (!plan.pricing) return plan;
              const pricingInfo = plan.pricing[selectedCountry][activeTab];
              return {
                ...plan,
                price: pricingInfo.price,
                id_add: pricingInfo.id_add,
              };
            });
            setpricingPlansnew(updatedPlans);
            // storeData("category", final_data.edit_business[0].business_website_url);
          }
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    master_data_get();
    detectUserCountry();
  }, []);

  return (
    <>
      {ShowLoaderAdmin && <Loader />}
      <div style={{ height: "100vh", overflow: "hidden" }}>
        <div className="headerNew justify-content-between">
          <img src="assets/images/wowlogo.png" alt="WOW Reviews" />
          {activePlan != "" && (
            <Link to={"/"}>
              <button className="godashBtn">Dashboard</button>
            </Link>
          )}
        </div>
        <div
          className="container-lg"
          style={{ overflowY: "auto", height: "calc(100vh - 72px)" }}
        >
          <div className="PricingDiv">
            <div className="pricingTOpHead">
              <div className="d-flex gap-1 align-items-center">
                <img
                  src={electricIcon || "/placeholder.svg"}
                  alt="electricIcon"
                />
                <p>Pricing Plans</p>
              </div>
              <h1>Simple Plan for Build Business Like Yours</h1>
              {/* Tabs for switching between Monthly and Yearly */}
              <div className="tabs">
                <button
                  className={`tabButton ${
                    activeTab === "monthly" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("monthly")}
                >
                  Monthly
                </button>
                <button
                  className={`tabButton ${
                    activeTab === "yearly" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("yearly")}
                >
                  Annual <span className="freeText">(2 Month Free)</span>
                </button>
              </div>
            </div>

            <div className="row margnClass">
              {pricingPlansnew.map((plan, index) => (
                <div className="col-lg-4 col-md-6 col-sm-6 mt-3" key={index}>
                  <div
                    className={`DataprinceBox1 ${
                      activePlan === plan.price_amount ? "selected" : ""
                    }`}
                  >
                    <img
                      src={planImages[plan.imgSrc] || "/placeholder.svg"}
                      alt={`Plan ${index + 1}`}
                    />
                    <h3>{plan.title}</h3>
                    <p>{plan.description}</p>
                    {plan.price && (
                      <h1>
                        {plan.price}
                        <span style={{ fontSize: "14px", color: "gray" }}>
                          /month{" "}
                          {selectedCountry === "india"
                            ? "(Including GST)"
                            : "(Excl. Tax)"}
                        </span>
                      </h1>
                    )}
                    {activeTab === "yearly" && index !== 2 && (
                      <p className="billedText">Billed Annually</p>
                    )}

                    <div className="amount">
                      <button
                        className={
                          plan.id_add !== "0@@@0" ? "margin_55_top" : ""
                        }
                        onClick={() =>
                          plan.id_add !== "0@@@0"
                            ? handlepayment(plan)
                            : handleNavigate()
                        }
                      >
                        {plan.buttonText}
                      </button>
                    </div>
                    <ul>
                      {plan.features.map((feature, featureIndex) => (
                        <div className="d-flex margnLabal" key={featureIndex}>
                          <img
                            src={goodmarkImg || "placeholder.svg"}
                            alt="Goodmark"
                            className="GreenMarkImng"
                          />
                          <label>
                            <strong>{feature.text}</strong>{" "}
                            {feature.additionalText}
                          </label>
                        </div>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
